import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { ConsultationScheduler } from './booking/ConsultationScheduler';
import type { GuideDetails } from '../services/matchingService';

export const HomeSchedulePage: React.FC = () => {
    const navigate = useNavigate();
    const { guideId } = useParams<{ guideId: string }>();
    const location = useLocation();
    const guide = location.state?.guide as GuideDetails | undefined;

    if (!guide || !guideId) {
        navigate('/home', { replace: true });
        return null;
    }

    return (
        <ConsultationScheduler
            guide={guide}
            accountAlreadyCreated={true}
            onBack={() => navigate('/home')}
            onBookingComplete={() => navigate('/home')}
        />
    );
};
